import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isBlank", "tagName"];
import React from 'react';
import { Text as CarnicaText } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import { enhancedConnect } from "../../utils";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
var _Text = function _Text(_ref) {
  var isBlank = _ref.isBlank,
    tagName = _ref.tagName,
    props = _objectWithoutProperties(_ref, _excluded);
  var linkWindow = isBlank ? '_blank' : '_self';
  var target = props.href ? linkWindow : undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('normalize'),
    "data-t-id": "components-Text"
  }, /*#__PURE__*/React.createElement(CarnicaText, _extends({}, props, {
    allowHTML: true,
    tagName: tagName || 'p',
    target: target
  })));
};
export var Text = enhancedConnect()(_Text);